import { Compute } from 'cerebral'
import { props } from 'cerebral/tags'
import nodePathToArray from 'utils/nodePathToArray'

export default Compute(props`nodePath`, nodePath => {
  if (!nodePath) return null
  return nodePathToArray(nodePath).reduce((acc, subpath, index) => {
    return [
      ...acc,
      !index
        ? `node.nodes.${subpath}`
        : acc[index - 1].concat(`.nodes.${subpath}`)
    ]
  }, [])
})



// WEBPACK FOOTER //
// ./src/modules/Node/computed/crumbsFromNodePath.js